const IconData = [
    {
        img: 'https://res.cloudinary.com/devsprime/image/upload/v1625098145/Icons%20and%20Logo/Group_srbcyi.svg',
       
    },
    {
        img: 'https://res.cloudinary.com/devsprime/image/upload/v1625098145/Icons%20and%20Logo/Group_1_p5dbtf.svg',
       
    },
    {
        img: 'https://res.cloudinary.com/devsprime/image/upload/v1625098145/Icons%20and%20Logo/Group_2_xy74gs.svg',
       
    },
    {
        img: 'https://res.cloudinary.com/devsprime/image/upload/v1625098145/Icons%20and%20Logo/Group_3_cpwfti.svg',
    }
      

]

export default IconData;